import {
	OnboardedBuilderNetworkResponse,
	GetSelectionListByNameResult,
} from '@adsk/napi-api-client'
import React, { Dispatch } from 'react'
import { type Config } from '@adsk/napi-config'
import { type PixelCrop } from 'react-image-crop'
interface appExternalProps {
	showModal: boolean
	setShowModal: React.Dispatch<React.SetStateAction<boolean>>
	onSuccess?: () => void
	setIsBuildersProfileModalEnabled?: React.Dispatch<
		React.SetStateAction<boolean | undefined>
	>
	isBuildersProfileModalEnabled?: boolean | undefined
}

interface appInternalProps {
	isFetchFailure: boolean
	setIsFetchFailure: React.Dispatch<React.SetStateAction<boolean>>
}

export const ONBOARDING_FLOW = 'ONBOARDING_FLOW'
export const VIEW_EDIT_PROFILE_FLOW = 'VIEW_EDIT_PROFILE_FLOW'

export type SupportedProfilePictureAction = 'upload' | 'remove'
export type FileInfoType = {
	action?: SupportedProfilePictureAction
	cropProps: {
		canvasRef: HTMLCanvasElement
		pixelCrop: PixelCrop
	}
	imageRefElement: HTMLImageElement
	file: File
}

export type OnboardingUserAppErrorType = {
	message?: string
}
export type UserInfoType = Partial<OnboardedBuilderNetworkResponse> & {
	updatedAvatarUrl?: string
}

export type OnboardingUserAppState = {
	flowType?: string
	userInfo?: UserInfoType
	profileReadOnlyMode?: boolean
	fileInfo?: FileInfoType
	submitState: boolean
	displaySubmitButtonLoader: boolean
	showLoader: boolean
	errorInfo?: OnboardingUserAppErrorType
	config?: Config
	selectionsList: Array<GetSelectionListByNameResult>
	marketingCompanyType: Record<string, boolean>
	immutableUserInfo?: UserInfoType
	userInfoChanged: boolean
}
type SupportedPayloadTypes =
	| SupportedProfilePictureAction
	| Partial<OnboardedBuilderNetworkResponse>
	| Partial<OnboardingUserAppState>
	| boolean
	| string
	| OnboardingUserAppErrorType
	| Partial<FileInfoType>
	| Config
	| Array<GetSelectionListByNameResult>

export type OnboardingUserAppAction = {
	type: string
	payload?: SupportedPayloadTypes
}

export type OnboardingUserAppContextType = {
	state: OnboardingUserAppState
	dispatch: Dispatch<OnboardingUserAppAction>
	externalProps?: appExternalProps
	internalProps?: appInternalProps
}

export type OnboardingUserAppProviderProps = {
	customInitialState?: OnboardingUserAppState
	children: React.ReactNode
	externalProps?: appExternalProps
	internalProps?: appInternalProps
}
export const ActionStates = {
	SET_USER_INFO: 'SET_USER_INFO',
	SET_FLOW_TYPE: 'SET_FLOW_TYPE',
	RESET_AVATAR_CURRENT_SELECTION_STATE: 'RESET_AVATAR_CURRENT_SELECTION_STATE',
	SET_PROFILE_PICTURE_ACTION: 'SET_PROFILE_PICTURE_ACTION',
	TOGGLE_PROFILE_READ_ONLY_MODE: 'TOGGLE_PROFILE_READ_ONLY_MODE',
	DISPLAY_SUBMIT_BUTTON_LOADER: 'DISPLAY_SUBMIT_BUTTON_LOADER',
	SUBMIT_STATE: 'SUBMIT_STATE',
	RESET_STATE: 'RESET_STATE',
	SET_ERROR_INFO: 'SET_ERROR_INFO',
	UPDATE_AVATAR_FILE_STATE: 'UPDATE_AVATAR_FILE_STATE',
	UPDATE_CROPPED_STATE: 'UPDATE_CROPPED_STATE',
	SHOW_LOADER: 'SHOW_LOADER',
	UPDATE_APP_CONFIG: 'UPDATE_APP_CONFIG',
	SET_SELECTIONS_LIST: 'SET_SELECTIONS_LIST',
	SET_MARKETING_COMPANY_TYPE: 'SET_MARKETING_COMPANY_TYPE',
	SET_IMMUTABLE_USER_INFO: 'SET_IMMUTABLE_USER_INFO',
	SET_USER_INFO_CHANGED: 'SET_USER_INFO_CHANGED',
}
